import { ArticleInterface } from "../index";
import mainImg from "./toast.jpeg";

export const contents: ArticleInterface = {
    contents: [
        {
            content: `It’s been so long since that dreaded day we had to empty our rooms for just a couple of weeks, 
                and now we’ve ended up graduating. People say that college years are always going to be the best years of your life. 
                I disagree. College is an experience I wouldn’t trade anything for, but the best years of your life depend upon your life 
                and not just college. What can be said about college time, however, is that it’s going to be filled to the brim with memories, 
                memories that you would never forget, and memories that you would want to forget but memories nonetheless. 
                To me, the most memorable part of NITK is always going to be freedom, and oddly enough, it being a judgment-free zone, 
                at least with friends. The memories that we have had have been so varied. Some are as simple and wholesome as those talks in 
                friends’ rooms about stuff as random as it can be and dreading the awful smells of bathrooms in LHC-A to memories as convoluted and 
                disheartening as the various instances of gender stereotyping done by the admin dept. 
                It’s incredible how we have these highly varied perceptions of the same place and share them among ourselves in such an open manner.`,
            contentType: "text",
        },
        {
            contentType: "text",
            content: `Yet despite all the variations, for most of us, if not all, 
                we’ve seen it as a place where we’ve grown, matured, and become better people in every sense of the word. 
                We entered college as clueless and disorganized teenagers, and now when we’re about to leave, 
                well we’re still pretty clueless and I know I’m no more organized than I used to be, 
                but at least now we’re much more confident about being unsure so I guess that counts. 
                On a more serious note, college has introduced us to people that have helped shape our college life, 
                the people that we’ll keep in our memories for years from now. In much the same way we have also been 
                significant and central to others’ college lives. All leading to memories, regrets, and well, that’s life. 
                That’s what college life has meant to me, and there are memories of all kinds, 
                ones that I’d want to cherish and ones that I would never want to think of again. 
                I have been proudly used to claiming not having regrets, but thanks to a global pandemic, even that has changed.`,
        },
        {
            contentType: "text",
            content: `I’m grateful to be healthy, but I regret not getting closure and having moments like this 
                on campus, where they would have been intensified multiple fold. It’s an oddly admirable place, 
                one full of the weirdest of memories, where the campus is the only common denominator. 
                It’s in memory of this comforting yet irritating, admirable yet at times disheartening, 
                that I ask you to raise your glass and join me in toasting our memorable campus, NITK.`,
        },
    ],
    cardData: {
        description:
            "A toast to our batch and our unfortunate online graduation",
        image: mainImg,
        isTech: false,
        title: "Batch of 2021",
    },
};
